import { useRef, useEffect, useState } from 'react';
import { HdrDetails } from '#server/models/hdr';
import { ColumnFiltersState } from '@tanstack/react-table';
import { SheetContent } from '@/components/ui/sheet';
import { useAwmsStore } from '@/store';
import { useHandleError, useHdrDetails } from '@/hooks';
import { FILTERS } from '@/constants';
import { HdrHeader } from './HdrHeader';
import { HdrTable } from './HdrTable';

export const Hdr = ({ setHasSavedHdr }: { setHasSavedHdr: React.Dispatch<React.SetStateAction<boolean>> }) => {
  const activeYear = useAwmsStore((state) => state.activeYear);
  const selectedStaff = useAwmsStore((state) => state.selectedStaff);
  const selectedStaffId = selectedStaff?.id ?? 0;
  const searchFilters = useAwmsStore((state) => state.searchFilters);
  const selectedSchool = searchFilters[FILTERS.SCHOOL];
  const selectedSchoolId = selectedSchool?.value ?? 0;
  const sheetRef = useRef<HTMLDivElement | null>(null);
  const [columnFilters, setColumnFilters] = useState<ColumnFiltersState>([]);
  const [chairAllowance, setChairAllowance] = useState(0);
  const [supervisorAllowance, setSupervisorAllowance] = useState(0);
  const [filteredHdrDetails, setFilteredHdrDetails] = useState<HdrDetails[]>([]);
  const handleError = useHandleError();
  const [isPageLoading, setIsPageLoading] = useState(true);
  const {
    data: hdrDetails = [] as HdrDetails[],
    isLoading: isHdrDetailsLoading,
    error: hdrDetailsError,
  } = useHdrDetails(selectedSchoolId, selectedStaffId);

  useEffect(() => {
    if (hdrDetailsError) {
      console.error('Error fetching data:', { hdrDetailsError });
    }
    handleError([hdrDetailsError]);
  }, [hdrDetailsError, handleError]);

  useEffect(() => {
    setIsPageLoading(isHdrDetailsLoading);
  }, [isHdrDetailsLoading]);

  useEffect(() => {
    if (hdrDetails && hdrDetails.length > 0) {
      setChairAllowance(hdrDetails[0]?.hdrThesisChairAllowance ?? 0);
      setSupervisorAllowance(hdrDetails[0]?.hdrSupervisorAllowance ?? 0);
      const hdrDetailsFiltered = hdrDetails.filter((hdr) => hdr.hdrStudentWorkloadId !== 0);
      setFilteredHdrDetails(hdrDetailsFiltered);
    }
  }, [hdrDetails]);

  return (
    <SheetContent
      ref={sheetRef}
      className="flex !max-w-[1250px] flex-col items-start justify-start gap-y-10 border-l-0 bg-white p-0"
    >
      <HdrHeader
        staffDetails={selectedStaff}
        school={selectedSchool?.label ?? ''}
        year={activeYear.toString() ?? ''}
        chairAllowance={chairAllowance}
        supervisorAllowance={supervisorAllowance}
        setColumnFilters={setColumnFilters}
      />
      <HdrTable
        parentRef={sheetRef}
        hdrDetails={filteredHdrDetails}
        isPageLoading={isPageLoading}
        columnFilters={columnFilters}
        setColumnFilters={setColumnFilters}
        setHasSavedHdr={setHasSavedHdr}
      />
    </SheetContent>
  );
};
